<template>
  <b-dropdown
    hoverable
    aria-role="list"
    position="is-bottom-left"
    :class="$style.dropDownAction"
  >
    <span class="icon has-text-primary" slot="trigger" role="button">
      <slot name="icon">
        <i class="fa fa-ellipsis-h"></i>
      </slot>
    </span>
    <slot />
  </b-dropdown>
</template>

<script lang="ts">
import Component from 'vue-class-component';
import { Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class TableDropdown extends Vue {}
</script>
<style lang="scss" module>
.dropDownAction {
  :global .dropdown-menu {
    .dropdown-content {
      padding: 0;

      .dropdown-item {
        border-bottom: 1px solid #dbdbdb;

        &:hover,
        label {
          background: #f7fbff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
